import TourCriteriaObjectValue from '@/js/common/Domain/ObjectValue/TourCriteria';

const currentTourCriteria = new TourCriteriaObjectValue();

const defaults = {
    searchData: currentTourCriteria,
    filterCriteria: null,
    beforeToursLoading: true,
    sortStrategy: (document.location.hash.indexOf('identity=') === -1) ? 'priceUp' : 'identity',
    selectedSortValue: 0,
    numOfTourPerPage: 5,
    selectedIdentity: null,
    loadingState: 'loading', //"loading", "asyncLoading", "finished"
    loadingInProgress: false,
    syncTourProducts: null,
    asyncTourProducts: null,
    countryIsClose: false,
    filteredTourProductsWithSimilarTours: [],
    pageNumber: 0,
    subscribeState: '0',
    thEmail: '',
    hotelInfo: null,
    desiredCollectionLength: 0,
    searchStartCounter: 0,
    urlParams: null,
};

export default defaults;